import * as yup from '@if/core/yup'
import type { InferType } from '@if/core/yup'

const SECRET_NAME_REGEX = /^[a-zA-Z0-9\-_]+$/

export const newSecretsSchema = yup.object({
  keyVaultName: yup.string().required('common.errors.required'),
  secrets: yup
    .array()
    .of(
      yup.object({
        key: yup
          .string()
          .required('keyVault.validation.secretNameRequired')
          .max(50, 'keyVault.validation.secretNameMaxLength')
          .matches(SECRET_NAME_REGEX, 'keyVault.validation.secretNameFormat'),
        value: yup.string().required('keyVault.validation.secretValueRequired'),
      }),
    )
    .required()
    .min(1),
})

export type NewSecretsFormData = InferType<typeof newSecretsSchema>
